module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-notfound"
  }, [_c('top-subpage-section'), _vm._v(" "), _c('div-container', [_c('div', {
    staticClass: "hero is-primary",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('div', {
    staticClass: "hero-body content has-text-centered"
  }, [_c('div', {
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n            Uh oh\n          ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n            404 Page Not Found\n          ")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6066df7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NotFound.vue
// module id = 918
// module chunks = 1